import api from '@/shared/api';

export const fetchCompanyInfo = companyRegistrationNumber => {
  return api.get('/company_information', { params: { companyRegistrationNumber } })
  .then(({ data }) => {
    return data;
  });
};
